<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <div>
        <h1>{{ $t("blog.header") }}</h1>
        <div class="h1-subtitle text-center">
          {{ tagDescription?.data?.name }}
        </div>
        <div class="flex md:flex-row flex-col max-w-4xl md:w-full md:mx-auto my-20 mx-4">
          <div
            class="p-quote-blog-intro-text text-left md:text-center"
            v-html="tagDescription?.data?.description"
          ></div>
        </div>
      </div>

      <BlogPosts :tag="tagDescription?.data?.id"></BlogPosts>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
import { useGlobalStore } from "@/stores/global";
const globalStore = useGlobalStore();
const site = () => globalStore.siteCurrentLocale;
defineI18nRoute({
  locales: ["en", "es"],
});
const { data: tagDescription, pending, refresh } = await useTagDetail(route.params.slug, site);
if (import.meta.client && !tagDescription.value?.data) await refresh();

const breadcrumbs = getBreadcrumbs("blog-tag", tagDescription.value?.data ?? {});
</script>
